export default "__VITE_ASSET__C07jooRM__"